import { NgModule } from '@angular/core';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { MeSelfReportRoutesModule } from './me-self-report.routes';
import { MeSelfReportComponent } from './me-self-report.component';
import { MeSelfReportHelpCardComponent } from './help-card/help-card.component';
import { MeSelfReportDifficultiesComponent } from './difficulties/difficulties.component';
import { MeSelfReportLivingConditionsComponent } from './living-conditions/living-conditions.component';
import { MeSelfReportPersonalInformationComponent } from './personal-information/personal-information.component';
import { MeSelfReportSuccessCardComponent } from './success-card/success-card.component';
import { MeSelfReportDashboardCardComponent } from './dashboard-card/dashboard-card.component';

@NgModule({
    imports: [
        BaseModule,
        MeSelfReportRoutesModule,
        StoryBlokLinkModule
    ],
    declarations: [
        MeSelfReportLivingConditionsComponent,
        MeSelfReportDifficultiesComponent,
        MeSelfReportHelpCardComponent,
        MeSelfReportPersonalInformationComponent,
        MeSelfReportSuccessCardComponent,
        MeSelfReportDashboardCardComponent,
        MeSelfReportComponent
    ],
    exports: [
        MeSelfReportComponent,
        MeSelfReportDashboardCardComponent,
        MeSelfReportComponent
    ]
})
export class MeSelfReportModule { }
